<template>
      <div class="mt-2 text-base text-center font-ww-regular">
           {{ limitedSuppliesText }}
           </div>
    <section class="px-4 py-6 mx-auto max-w-7xl md:py-12 xl:px-4" :style="{ backgroundColor: backgroundColor }">
        <div class="flex flex-col items-center gap-x-6 md:flex-row gap-y-3">
            <nuxt-img :src="logoSrc" sizes="xs:300px sm:302px md:302px lg:302px xl:302px" format="webp" loading="lazy" width="302" height="84" class="h-fit md-max:w-52" :alt="logoAlt" style="max-width: 75px !important;" />
            <div class="text-base xl:text-lg font-ww-regular !leading-6 text-left" v-html="description"></div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    limitedSuppliesText: {
        type: String,
        default: "Limited supplies available. Special discount available today."
    },
    logoSrc: {
        type: String,
        default: "/assets/images/decaf-logos.png"
    },
    logoAlt: {
        type: String,
        default: "Decaf Coffee"
    },
    description: {
        type: String,
        default: `
            On top of low acidity, Lifeboost Coffee has none of the junk swimming around in most coffees that
            aggravates your stomach. That's why we test for <strong> pesticides, chemicals, GMOs, or mycotoxins.</strong>
            <br><br>
            That means nothing
            that careless farmers and profit-hungry manufacturers use to get their brews out the door fast.
        `
    },
    backgroundColor: {
        type: String,
        default: "white"
    }
});

defineBuilderComponent({
    friendlyName: "LogoRightText",
    inputs: [
        {
            name: "limitedSuppliesText",
            type: "text",
            friendlyName: "Limited Supplies Text",
            defaultValue: "Limited supplies available. Special discount available today."
        },
        {
            name: "logoSrc",
            type: "file",
            friendlyName: "Logo Image",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/decaf-logos.png"
        },
        {
            name: "logoAlt",
            type: "text",
            friendlyName: "Logo Alt Text",
            defaultValue: "Decaf Coffee"
        },
        {
            name: "description",
            type: "richText",
            friendlyName: "Description",
            defaultValue: `
                On top of low acidity, Lifeboost Coffee has none of the junk swimming around in most coffees that
                aggravates your stomach. That's why we test for <strong> pesticides, chemicals, GMOs, or mycotoxins.</strong>
                <br><br>
                That means nothing
                that careless farmers and profit-hungry manufacturers use to get their brews out the door fast.
            `
        },
        {
            name: "backgroundColor",
            type: "color",
            friendlyName: "Background Color",
            defaultValue: "white"
        }
    ]
});
</script>
